// omit data.luaModules and force array
import { useControlProxy, normalizeResponse } from 'api/control/useControlProxy';
import { METHOD, PATH } from 'api/control/control-api';
import permissions from 'api/Apollo/permissions';

function extractLuaModulesFromData(data) {
  if (!Array.isArray(data?.luaModules)) {
    return [];
  }

  return data.luaModules;
}

export { extractLuaModulesFromData };

// lua modules = transformation library = transformation modules
function useGetLuaModules(options = {}) {
  const [call, response] = useControlProxy({ permission: permissions.readLuaModules, ...options });

  const getLuaModules = ({ clusterId, body }) => {
    return call({
      path: PATH.LuaModules,
      method: METHOD.GET,
      body: { ...body },
      clusterId,
    });
  };

  const normalizedResponse = normalizeResponse(response, extractLuaModulesFromData);

  return [getLuaModules, normalizedResponse];
}

export default useGetLuaModules;
